<div class="error-wrapper">
  <div class="error">
    <div class="logo__error">
      <img src="assets/images/logo.svg">
    </div>

    <div class="error__inner">
      <div class="icon-wrapper">
        <i class="fal fa-exclamation-circle" style="font-size: 65px;"></i>
      </div>
      <h1>Error 404 - Not Found</h1>
      <p>Page not found</p>
      <p><a (click)="toHome()" class="error-btn">Go to Home</a></p>
    </div>
  </div>
</div>
